import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { HomeProjectSection } from '../common/HomeProjectSection.js';
import { makeSearchURL } from '../common/searchRequestUtils.js';
import { extractSuggestionLocationParameters, getLocationText } from '../common/locationUtils.js';

let LocalProjectsSection = function (props) {
    const detectedLocation = props.detectedLocation;

    if (!detectedLocation) {
        return null;
    }

    const searchURL = props.baseSearchURL + '?hasPhoto=true';
    const local = makeSearchURL(extractSuggestionLocationParameters(detectedLocation), searchURL);
    const description = 'NEAR ' + getLocationText(local);

    return (
        <HomeProjectSection searchURL={local} title="Nearby projects"
            projects={props.getProjects(local)} loadProjects={props.loadProjects}
            className="projects-nearby"
            description={description} />
    );
};

LocalProjectsSection.propTypes = {
    baseSearchURL: PropTypes.string.isRequired,
    loadProjects: PropTypes.func.isRequired,
    getProjects: PropTypes.func.isRequired,

    detectedLocation: PropTypes.object,
};
LocalProjectsSection = React.memo(LocalProjectsSection);
export default LocalProjectsSection;
